import { render, staticRenderFns } from "./CertificateDetails.vue?vue&type=template&id=598a3d12&scoped=true"
import script from "./CertificateDetails.vue?vue&type=script&lang=ts"
export * from "./CertificateDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598a3d12",
  null
  
)

export default component.exports